Vue.component('ack-distributor-dashboard', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-distributor-dashboard',
	mixins: [languageMixins],
	created() {},
	mounted() {
		this.setPageIsLoading(false);
	},
	props: {},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		//...Vuex.mapGetters('articles', ['articlesArray']),
		isMobile() {
			return this.$parent.isMobile;
		},
	},
	data() {
		return {
			pageId: 'distributor-dashboard-page',
			currentTab: 'home',
		};
	},
	methods: {
		setTab(tab) {
			this.currentTab = tab;
		},

		scrollToTop() {
			window.scrollTo({ top: 300, left: 100, behavior: 'smooth' });
		},
	},
	beforeDestroy() {},
	watch: {
		currentTab: {
			handler() {
				//this.scrollToTop()
			},
			deep: false,
		},
	},
});
